<!-- Top menu -->
<div class="overflow-y-scroll no-scrollbar">
  <!-- Tree -->

  <!-- Empty state -->
  <div
    *ngIf="periodicTagNodes.length === 0 && nonPeriodicTagNodes.length === 0"
  >
    <h2 class="uppercase text-sm tracking-wider mb-4 mt-2">Tags</h2>
    <span class="italic">Your Tags will show up here.</span>
  </div>

  <div>
    <h2
      *ngIf="periodicTagNodes.length > 0"
      class="uppercase text-sm tracking-wider mb-4 mt-2"
    >
      Fixed Tags
    </h2>
    <tag-tree
      [tag]="tag"
      (onTagClick)="onTagClick.emit({ tag: $event })"
      [tagNodes]="nonPeriodicTagNodes"
      [detailedTags]="detailedTags"
    ></tag-tree>
  </div>

  <div *ngIf="periodicTagNodes.length > 0">
    <div class="flex justify-between my-4">
      <h2 class="uppercase text-sm tracking-wider">Periodic Tags</h2>
      <span class="!text-slate-400">
        <mat-icon
          class="cursor-pointer align-middle scale-[.6]"
          (click)="previousPeriodClick()"
          >arrow_back_ios</mat-icon
        >
        <span class="!text-slate-400"
          >{{ periodService.current.year }} /
          {{ periodService.current.month }}</span
        >
        <mat-icon
          class="cursor-pointer align-middle scale-[.6]"
          (click)="nextPeriodClick()"
          >arrow_forward_ios</mat-icon
        >
      </span>
    </div>
    <tag-tree
      #periodicTagTree
      [tag]="tag"
      (onTagClick)="
        onTagClick.emit({ tag: $event, period: periodService.current })
      "
      [tagNodes]="periodicTagNodes"
      [detailedTags]="detailedTags"
    ></tag-tree>
  </div>
</div>

<!-- Bottom menu -->
<mat-nav-list class="!pb-0">
  <mat-list-item (click)="onAllEntriesClick.emit()" [activated]="!tag">
    <div class="flex justify-between items-center w-full">
      <span class="flex items-center"
        ><mat-icon class="mr-2">description</mat-icon> All entries</span
      >
      <span class="shortcut hidden text-slate-400">Shortcut: A</span>
    </div>
  </mat-list-item>

  <mat-list-item (click)="openPlannerDialog()">
    <div class="flex justify-between items-center w-full">
      <span class="flex items-center"
        ><mat-icon class="mr-2">design_services</mat-icon> Planner</span
      >
      <span class="shortcut hidden text-slate-400">Shortcut: P</span>
    </div>
  </mat-list-item>

  <!-- TODO: https://kanbanflow.com/t/qJt4HjQy -->
  <mat-list-item (click)="openSettingsDialog()">
    <div class="flex justify-between items-center w-full">
      <span class="flex items-center"
        ><mat-icon class="mr-2">settings</mat-icon> Settings</span
      >
      <span class="shortcut hidden text-slate-400">Shortcut: S</span>
    </div>
  </mat-list-item>
</mat-nav-list>
